export class Fixed {
  constructor(options = {}) {
    this.getContainer = options.getContainer || getContainer;

    this.show = false;

    this.offset = options.offset || 0;

    this.el = options.el || null;

    this.container = this.getContainer();

    this.containerInner =
      this.container === window ? document.body : this.container;

    this.scrollListener = this._scrollListener.bind(this);

    this.headerCopied = headerClone({ el: this.el });

    insert(this.containerInner, this.headerCopied);

    this.bind();
  }

  _scrollListener() {
    let top = getTop(this.el);

    if (top === null) return;

    let isShow = top <= this.offset;

    if (isShow === this.show) return;

    displayToggle(this.headerCopied, isShow);

    this.show = isShow;
  }

  bind() {
    this.container &&
      this.container.addEventListener("scroll", this.scrollListener, null);
  }

  destroy() {
    if (this.container) {
      this.container.removeEventListener("scroll", this.scrollListener, null);
    }

    if (this.headerCopied && this.containerInner) {
      this.containerInner.removeChild(this.headerCopied);
    }
  }
}

export default Fixed;

function getContainer() {
  return window;
}

function headerClone({ el }) {
  const headerWrapper = el.querySelector(".gt-table__header-wrapper");

  const copied = document.createElement("div");

  copied.className = "gt-table gt-table--fixed";
  copied.style.position = "sticky";
  copied.style.top = "0px";
  copied.style.zIndex = "4";
  copied.style.width = "100%";
  copied.style.display = "none";

  copied.appendChild(headerWrapper.cloneNode(true));

  return copied;
}

function getTop(el) {
  const { x, y, top } = el.getBoundingClientRect();

  if (!x && !y) {
    return null;
  }

  return top;
}

function displayToggle(el, value = true) {
  el && (el.style.display = value ? "block" : "none");
}

function insert(parent, el) {
  parent.insertBefore(el, parent.firstChild);
}
